import { render, staticRenderFns } from "./landing-page-puppy-pack-section.vue?vue&type=template&id=190c7f8a&scoped=true&lang=pug"
import script from "./landing-page-puppy-pack-section.js?vue&type=script&lang=js&external"
export * from "./landing-page-puppy-pack-section.js?vue&type=script&lang=js&external"
import style0 from "./landing-page-puppy-pack-section.vue?vue&type=style&index=0&id=190c7f8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190c7f8a",
  null
  
)

export default component.exports